var _rect, _g, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 20,
    fill: "#FFDAC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5562_163501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3863 30.8594H20.649C19.0664 30.8613 17.5492 31.4908 16.4302 32.6099C15.3111 33.7289 14.6816 35.2461 14.6797 36.8287V42.9015H36.3555V36.8287C36.3536 35.2461 35.7241 33.7289 34.6051 32.6099C33.486 31.4908 31.9688 30.8613 30.3863 30.8594V30.8594Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5172 27.2453C28.8425 27.2453 31.5382 24.5495 31.5382 21.2242C31.5382 17.8989 28.8425 15.2031 25.5172 15.2031C22.1918 15.2031 19.4961 17.8989 19.4961 21.2242C19.4961 24.5495 22.1918 27.2453 25.5172 27.2453Z",
    fill: "#FE9452"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5469,
    y: 27.8164,
    width: 13.4333,
    height: 13.4333,
    rx: 6.71667,
    fill: "#FD6202"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5469,
    y: 27.8164,
    width: 13.4333,
    height: 13.4333,
    rx: 6.71667,
    stroke: "#FFDAC4",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2654 33.6914L36.1659 31.5919L35.3261 32.4317L37.4256 34.5312L35.3261 36.6308L36.1659 37.4706L38.2654 35.3711L40.3649 37.4706L41.2047 36.6308L39.1052 34.5312L41.2047 32.4317L40.3649 31.5919L38.2654 33.6914Z",
    fill: "#FFDAC4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5562_163501"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.0664,
    y: 14,
    width: 28.9011,
    height: 28.9011,
    rx: 14.4506,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCustomers);
export default __webpack_public_path__ + "static/media/inactiveCustomers.47b520d30792be2b8e303de3c38aeb60.svg";
export { ForwardRef as ReactComponent };